import { DisplayConfigurationValueEnum } from '../Core';
import { CoreUtils } from '../Core';
import { getDisplayConfiguration } from './accessors';
export function filterRacialTraitsByDisplayConfigurationType(racialTraits, displayConfigurationType) {
    return racialTraits.filter((racialTrait) => {
        const displayConfiguration = getDisplayConfiguration(racialTrait);
        if (!displayConfiguration) {
            return true;
        }
        const displayConfigurationValue = CoreUtils.getDisplayConfigurationValue(displayConfigurationType, displayConfiguration);
        return DisplayConfigurationValueEnum.ON === displayConfigurationValue;
    });
}
